import { actionTypes}  from '../action/action';
import {deviceState} from '../../base/models/meetModal';

const initialState = {
  isAudio:false,
  isAudioStatus:'',
  isVideo:false,
  isVideoStatus:''
};

export const mediaDeviceInfo = (state: deviceState = initialState, action: any) => {
  const {
    type,
    payload
  } = action;
  switch (type) {
  case actionTypes.MEDIADEVICEINFO:
    return {
      ...state, isAudio: payload.isAudio, isAudioStatus:payload.isAudioStatus,
      isVideo:payload.isVideo, isVideoStatus:payload.isVideoStatus
    };
  default:
    return state;
  };
};